import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  isActive: boolean;
  label: string;
  onEdit?: () => void;
  stepNumber: number;
  stepsTotal: number;
  isEditVisible?: boolean;
};
export const ReservationBlockHeader = ({
  isActive,
  label,
  onEdit,
  stepNumber,
  stepsTotal,
  isEditVisible = true,
}: Props) => (
  <div
    className={classnames('flex items-baseline justify-between gap-10 text-14 font-bold', {
      'text-black': isActive,
      'mb-10 text-grey': !isActive,
    })}
  >
    <p>
      {stepsTotal > 1 && (
        <Fragment>
          {stepNumber}
          <span className="text-12">/{stepsTotal}</span>
          &nbsp;-&nbsp;
        </Fragment>
      )}
      {label}
    </p>
    {!isActive && onEdit && isEditVisible && (
      <button
        className="flex cursor-pointer items-center gap-5 whitespace-nowrap text-12 text-black hocus:text-black-active"
        onClick={onEdit}
        type="button"
      >
        <Icon name={ICONS.PEN} width="1em" />
        <span className="underline">{t('common.edit')}</span>
      </button>
    )}
  </div>
);
